var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardLayout',{staticClass:"container"},[_c('ClientSearch',{attrs:{"value":_vm.clientSearch},on:{"input":function($event){return _vm.setClientSearch($event)}}}),_c('ClientList',{attrs:{"search":_vm.clientSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }